// extracted by extract-css-chunks-webpack-plugin
module.exports = {"suggestionImage":"VpN8Eg","suggestionWrapper":"_3fD7p3"};